import React, {useContext, useEffect, useState} from "react";
import Dropdown from "react-dropdown";
import OutsideClickHandler from 'react-outside-click-handler';
import {store} from "../../Store/store";

export default function ConfirmationDropdownEditor({row, options, value, toggleCommCheckBox, handleOnEdit, onUpdate, updateStateArr}) {
    const [isEditing, setIsEditing] = useState(true);
    const stateObj = useContext(store);
    const alertsStateArr = stateObj.state.alertsStateArr;
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const dropDownDisabled = isRequestInProgress.state && isRequestInProgress.rowId === row.id;

    const getConfirmationValue = () => {
        const reason = options.filter(option => {
            let one = option.value.toString();
            let two = value.toString();
            return one === two;
        })
        return reason;
    }

    const currentValue = getConfirmationValue()

    useEffect(() => {
        if (isEditing) {
            toggleCommCheckBox(true, row.id);
            handleOnEdit(true);
        }
    }, [isEditing])

    const finalizeEditing = () => {
        toggleCommCheckBox(false, row.id);
        setIsEditing(false);
        handleOnEdit(false);
    }
    const handleChange = (e) => {
        finalizeEditing();
        if (e.value === 0) {
            const newArr = alertsStateArr.map(object => {
                if (object.id === row.id) {
                    return {...object, confirmation: e.value, reason: null}
                }
                return object;
            });
            updateStateArr(newArr);
        }
        onUpdate(e.value);
    };

    return (<OutsideClickHandler
        onOutsideClick={() => {
            finalizeEditing();
            onUpdate(currentValue[0].value);
        }}
    >
        <Dropdown controlClassName='dropDownControl' menuClassName='menuControl' value={currentValue[0].label} options={options}
                  disabled={dropDownDisabled}
                  onChange={handleChange}/>
    </OutsideClickHandler>)
}
